import { render, staticRenderFns } from "./RegisteredAddress.vue?vue&type=template&id=829accc2"
import script from "./RegisteredAddress.vue?vue&type=script&lang=js"
export * from "./RegisteredAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports